import { PropsWithChildren } from "react";

// Secondary button (researcher): navy background, white text
const SecondaryButton = ({
  type,
  children,
  className,
  disabled,
  onClick
}: PropsWithChildren<{
  type?: "button" | "submit" | "reset";
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
}>) => (
  <button
    type={type || "button"}
    className={
      "rounded-[5px] px-4 py-2 font-medium " +
      (disabled
        ? "bg-ctb-grey-700 text-white "
        : "bg-[#010D2C] text-white ") +
      (className || "")
    }
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </button>
);

export default SecondaryButton;


